<template>
  <div class="menu">
    <span
      v-for="(menu,index) in menuContents"
      :key="index">
      <div
        :class="['menu-component', {'menu-component-selected': $route.path === menu.path}]"
        @click="setView(menu.path)">
        <div class="menu-component-left">
          <span class="material-icons">
            {{ menu.icon }}
          </span>
          <span class="menu-title">
            {{ menu.title }}
          </span>
        </div>
        <span
          v-if="menu.notification"
          class="material-icons notification">
          notifications_active
        </span>
      </div>
    </span>
  </div>
</template>

<script>
import config from '@/utils/const'
import {db} from '@/plugins/firestore'
import sw from '@/utils/sweetAlert'

export default {
  data () {
    return {
      /**
       * メニューコンテンツ
       * @type {Array}
       */
      menuContents: [
        {
          title: '送信先設定',
          icon: 'email',
          path: '/settings/mail'
        },
        {
          title: '組織設定',
          icon: 'group',
          path: '/settings/organization',
          notification: false
        }
      ]
    }
  },
  computed: {
    // hack: computedとwatchはどちらかにしたい
    import () {
      return this.$store.state.import
    }
  },
  watch: {
    import () {
      // 組織設定で自分がインポートを不正に中断していた場合
      if (this.$store.state.import.run === config.import.run.organization && this.$store.state.import.user === this.$store.state.currentUser.mail) {
        this.menuContents[1].notification = true // ベルマークを表示
      } else {
        this.menuContents[1].notification = false
      }
    }
  },
  async created () {
    // hack: 設定に必要な情報はどこかで一括して取得したい
    await db.doc('tenants/' + this.$store.state.tenant).get()
      .then((doc) => {
        this.$store.commit('setImport', doc.data().import || { run: config.import.run.none, user: '' })
      })
      .catch((error) => {
        sw.toastAlert('error', '取得に失敗しました')
        console.error('エラー:' + error)
      })

    if (this.$route.path === '/settings') {
      // ログイン済み管理者ユーザーの場合
      if (this.$store.state.currentUser && this.$store.state.isSignIn && this.$store.state.currentUser.isAdmin) {
        // 前回のインポート処理を不正に中断した場合
        if (this.$store.state.import.run && this.$store.state.import.user === this.$store.state.currentUser.mail) {
          await this.$swal({
            icon: 'info',
            html: `前回インポート処理を不正に中断しました。<br>ベルマークがある項目をご確認ください。`,
          })
        }
      }
    }
  },
  methods: {
    /**
     * 月、日、人表示を切り替える
     * @param {String} path 切り替え先のパス
     */
    setView (path) {
      // パスと今いるビューのパスが同じなら終了
      if (this.$route.path === path) {
        return
      }
      this.$router.push(path)
    }
  }
}

</script>

<style scoped>
.menu {
  float: left;
  background: #fff;
  width: 200px;
  height: calc(100% - 48px);
  margin: 16px 0;
  z-index: 6;
}
.material-icons {
  margin: 0 5px 0 0;
}
.menu-component {
  width: 100%;
  height: 40px;
  padding: 0 0 0 15px;
  font-size: 0.9em;
  color: #828282;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;
  justify-content: space-between;
}
.menu-component:hover {
  background: #e8f0fe;
}
.menu-component-selected .menu-title{
  color: #1a73e8;
}
.menu-component-left {
  display: flex;
  align-items: center;
  text-align: left;
}
.notification {
  color: orange;
  align-items: center;
  text-align: right;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Settings/Menu.vue